import React, { Component, Fragment } from "react";
import { connect } from 'react-redux';
import { CSSTransition } from "react-transition-group";
import { Tabs } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import General from './General';
import Payment  from './Payment';
import Payroll from './Payroll';
import Efos from './Efos';
import dashboard from '../../Actions/dashboard';
const { showDashboard } = dashboard.actions;
const { TabPane } = Tabs;

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.wrapperRef = React.createRef();
		this.closeDashboard = this.closeDashboard.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}
	
	componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
	}
	
	componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

	render() {		
		const { visible, data, dashboardLoading } = this.props;
		const { cfdi, payments, payroll, efos } = data;
		return (
			<Fragment>
			{ !dashboardLoading &&
				<CSSTransition in={visible} timeout={50} appear classNames="dashboard" >
					<div className="dashboard" ref={this.wrapperRef}>
						<h1 className="title">Dashboard</h1>				
						<CloseOutlined onClick={this.closeDashboard} />
						<Tabs defaultActiveKey="1">
							<TabPane tab="General" key="1">
								<General data = {cfdi} />
							</TabPane>
							<TabPane tab="Pagos" key="2">
								<Payment data = {payments} />
							</TabPane>
							<TabPane tab="Nóminas" key="3">
								<Payroll data = {payroll} />
							</TabPane>
							<TabPane tab="EFOS" key="4">
								<Efos data = {efos} />
							</TabPane>
						</Tabs>
					</div>
				</CSSTransition>
			}
			</Fragment>
		)
	}

	closeDashboard () {
		this.props.showDashboard(false);
	}

	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
			this.props.showDashboard(false);
		}
	}
}


const mapStateToProps = state => {		
	return {
		visible: state.dashboard.visible,
		data: state.dashboard.data,
		dashboardLoading: state._genericComponents.loading.find('dashboardLoading')
	};
};

const mapDispatchToProps = dispatch => {
	return {
		showDashboard(state) {
			dispatch(showDashboard(state));
		}
	}
	
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);